export default {
    token: '',
    color: '',
    setUserInfo(userInfo) {
        Object.assign(this, userInfo)
    }
}
